import{defineMessages}from'react-intl';

export default defineMessages({
label_description:{
id:'event_form.label_description',
defaultMessage:'Description'},

label_brand:{
id:'event_form.label_brand',
defaultMessage:'Brand'},

button_cancel:{
id:'add_contact_modal.label_cancel',
defaultMessage:'Cancel Edit'},

button_saving:{
id:'event_form.label_submit',
defaultMessage:'SAVING...'},

page_title:{
id:'event_form.page_title',
defaultMessage:'Request Brand Selling Support Visit '},

label_event_locations:{
id:'event_form.label_event_locations',
defaultMessage:'Location'},

date_label:{
id:'i18n.create_event_card.date_label',
defaultMessage:'Date'},

label_num_artists:{
id:'event_form.label_num_artists',
defaultMessage:'Number of Brand Partners'},

button_submit:{
id:'event_form.label_submit',
defaultMessage:'Submit'}});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/components/SellingSupportForm/SellingSupportForm.messages.js
// module id = 2397
// module chunks = 0